enum ServiceWorkerMessageType {
    CacheProgress = 0,
    Error = 1,
}

export default ServiceWorkerMessageType;
